import API from '@/models/API';

export default class CouponsOverview {
  constructor(item = {}) {
    this.coupon_id = item.coupon_id || null;
  }

  static get = (query) =>
    API.get(`/stores/${localStorage.getItem('storeId')}/coupons/redeemed${query}`);

  static getRedeemedCouponAndVoucherCodes = (coupon_id, query) =>
    API.get(
      `/stores/${localStorage.getItem('storeId')}/coupons/redeemed/coupon-claims/${coupon_id + query}`
    );
}
